import API from '@/api/callApi.js'
import endpoints from '@/api/endpoints';


export default {
    namespaced : true,
    state : {
        routers : {
            value : [],
            loaded : false,
            dialog : false,
            routerIsAdd : false,
            routerAddError : false,
            length : null,
            isReady : false,
        } 
    },
    mutations : {
        setRouterData (state, value) {
            state.routers.value = value;
        },
        setRouterLength (state, value) {
            state.routers.length = value;
        },
        setRouterDialog (state, value) {
            state.routers.dialog = value;
        },
        setLoaderStatus (state, value) {
            state.routers.loaded = value;
        },
        setApplicationReady (state, value) {
            state.routers.isReady = value;
        },
        setRouterIsAdd (state, value) {
            state.routers.routerIsAdd = value;
        },
        setRouterAddError (state, value) {
            state.routers.routerAddError = value;
        }
    },
    actions : {
        routerData ({ commit }) {
			API.makeGet(endpoints.baseURL + endpoints.endpoints.router, null, true)
			.then(response => {
                commit('setRouterData', response.data.payload);
                commit('setRouterLength', response.data.payload.length);
                commit('setApplicationReady', true);
			});
		},

        addRouter ({ commit, dispatch } , params) {
            commit('setLoaderStatus', true);
            API.makePost(endpoints.baseURL + endpoints.endpoints.createRouter, 
                {
                    'name' : params.boxReference,
                },true)
            .then( response => {
                dispatch('routerData');
                commit('setLoaderStatus', false);
                commit('ui/triggerAlert', {type:'success', msg:'Box ajouté avec succès'}, { root:true});
                commit('setRouterIsAdd', true);
                commit('setRouterDialog', false);
            })
            .catch (error => {                
                let m = error.response ? error.response.data : (error.request ? error.request.response  : error.message);
                commit('ui/triggerAlert', {type:'error', msg:'Votre Box n\'a pas pu être ajoutée '}, { root:true});
            })

        },

    }
};
